export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const WARNING = 'WARNING';
export const INFO = 'INFO';
export const SNACKBAR_CLEAR = 'SNACKBAR_CLEAR';